<template>
  <div class="home">
    <button class="inp inp2" @click="$emit('close')" style="float: right; width:280px">
      <back-icon/>
      Close and back (not finished)
    </button>
    <h3>Select print templates</h3>
    <p class="c"><i>serial numbers to be printed: <b>{{ toPrint.length }}</b> </i></p>
    <p class="c">
      <label><input type="checkbox" v-model="download"> download PDF file</label> &nbsp;&nbsp;
      <label><input type="checkbox" v-model="itembrake"/> row brake by itemCode</label>
    </p>
    <p class="c">
      Design:&nbsp;&nbsp;<label><input type="radio" value="Tomcat" v-model="company">
      Tomcat</label>&nbsp;&nbsp;&nbsp;<label><input
        type="radio" value="JTE" v-model="company"> JTE</label>
    </p>
    <div class="templates allowwrap">
      <div v-if="printTpl.length">
        <table width="100%">
          <tr>
            <td>Select template:</td>
            <td>
              <select name="dynamicTPL" class="inp" v-model="selectedTPL">
                <option value="">-- select template --</option>
                <option v-for="t in printTpl" :value="t">{{ t }}</option>
              </select></td>
          </tr>
        </table>
        <button class="inp  defcolor" @click="dynamicTemplate">Generate</button>
      </div>
      <hr>
      <div>
        <h4> Labels 2x3 (Letter 08A)</h4>
        <table width="100%">
          <tr>
            <td>Start on column:</td>
            <td><input type="number" min="1" max="2" class="inp c" v-model="templ_start[1].x"></td>
          </tr>
          <tr>
            <td>Start on row:</td>
            <td><input type="number" min="1" max="3" class="inp c" v-model="templ_start[1].y"></td>
          </tr>
        </table>
        <button class="inp  defcolor" @click="downloadTemplate(1)">Generate</button>
      </div>
      <hr>
      <div><h4> Labels 10x3 (Letter 04A)</h4>
        <table width="100%">
          <tr>
            <td>Start on column:</td>
            <td><input type="number" min="1" max="3" class="inp c" v-model="templ_start[2].x"></td>
          </tr>
          <tr>
            <td>Start on row:</td>
            <td><input type="number" min="1" max="10" class="inp c" v-model="templ_start[2].y"></td>
          </tr>
        </table>
        <button class="inp  defcolor" @click="downloadTemplate(2)">Generate</button>
      </div>
      <hr>
      <div><h4>Silver 4" wide Label</h4>
        <p class="c" style="color: #ccc"><i>no setting</i></p>
        <button class="inp  defcolor" @click="downloadTemplate(3)">Generate</button>
      </div>
    </div>
    <hr>
    <p class="c">
      <button class="inp defcolor" @click="markPrinted" style="width:350px">
        <check-icon/>
        ALL PRINTED CORRECTLY
      </button>
    </p>
  </div>
</template>

<script>
import BackIcon from "vue-material-design-icons/arrow-left"
import CheckIcon from "vue-material-design-icons/check-all"
import {mapState} from "vuex";

export default {
  name: "printing",
  props: ['toPrint'],
  components: {BackIcon, CheckIcon},
  computed: {
    ...mapState(['printTpl'])
  },
  data() {
    return {
      templ_start: [, {x: 1, y: 1}, {x: 1, y: 1}],
      download: false,
      company: 'Tomcat',
      itembrake: true,
      selectedTPL:''
    }
  },
  methods: {
    dynamicTemplate() {
       if (this.selectedTPL) {
         this.$store.dispatch('downloadPDF', {
           download: this.download,
           templateName: this.selectedTPL,
           serials: this.toPrint,
           company: this.company,
           itembrake: this.itembrake,
         });
       }
    },
    markPrinted() {
      this.$store.dispatch('markPrinted', this.toPrint);
      this.$emit('close');
    },
    downloadTemplate(id) {
      this.$store.dispatch('downloadPDF', {
        download: this.download,
        template: id,
        serials: this.toPrint,
        offset: this.templ_start[id],
        company: this.company,
        itembrake: this.itembrake
      });
    },
  },
  mounted() {
    this.$store.dispatch('getPrintTemplates');
  }
}
</script>

<style scoped>

</style>